import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useToast } from '@/hooks/use-toast';
import { ToastAction } from '@/components/ui/toast';

export function PwaUpdatePrompt() {
  const { toast } = useToast();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (!needRefresh) return;
    toast({
      title: 'עדכון חדש זמין — הקש לרענן',
      duration: Infinity,
      action: (
        <ToastAction
          altText="רענן"
          onClick={() => {
            setNeedRefresh(false);
            updateServiceWorker(true);
          }}
        >
          רענן
        </ToastAction>
      ),
    });
  }, [needRefresh, setNeedRefresh, updateServiceWorker, toast]);

  return null;
}

export default PwaUpdatePrompt;
